import { Grid } from "@mui/material";

import { MockLayoutNavigation } from "pages/LocalHomePage/components/MockLayoutNavigation";

import { PageLinks } from "./components/PageLinks";

export const LocalHomePage = () => {
  return (
    <Grid container direction="column" sx={{ px: 2 }}>
      <MockLayoutNavigation />
      <PageLinks />
    </Grid>
  );
};
